import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppPtiRanking } from '../models/mobileAppPtiRanking';

@Component({
  template: `<span class="{{ textClass }}">{{
    data[key] | roundsig: format
  }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BigNumberDataComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppPtiRanking;

  format: string = '0.00a';
  textClass: string = 'text-lowercase';

  ngOnInit(): void {
    super.ngOnInit();

    if (this?.header?.format) {
      if (this?.header?.format.indexOf(',') >= 0) {
        let f = this?.header?.format?.split(',');
        this.format = f[0];
        this.textClass = f[1];
      } else {
        this.format = this?.header?.format;
      }
    }
  }
}
